<template>
  <section class="donut-graph" :style="CSS_VARS">
    <div ref="graph" class="graph" />
    <div class="legend">
      <div v-for="(item, index) in dataset" :key="index" class="legend-item">
        <div class="legend-item-name">{{ item.legend.label }}</div>
        <div class="legend-item-color" :style="{ backgroundColor: item.color }"></div>
        <div class="legend-item-value">{{ item.legend.value }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import D3DonutGraph from '@/components/ecs-graphs/ecs-donut-graph/d3-donut-graph';

export default {
  name: 'EcsDonutGraph',

  props: {
    size: {
      type: Number,
      default: 120
    },
    dataset: {
      type: Array,
      default: null,
      example: [
        {
          color: 'red',
          value: 1,
          legend: {
            label: 'Title',
            value: 'One'
          }
        }
      ]
    }
  },

  computed: {
    CSS_VARS() {
      return {
        '--graph-size': `${this.size}px`
      };
    }
  },

  watch: {
    dataset: {
      deep: true,
      handler() {
        this.draw();
      }
    }
  },

  async created() {
    await this.$nextTick();
    this.draw();
  },

  methods: {
    async draw() {
      this.$refs.graph.replaceChildren();
      await this.$nextTick();
      this.graph = new D3DonutGraph(this.$refs.graph, this.dataset);
      this.graph.render();
    }
  }
};
</script>

<style src="./scoped.scss" scoped lang="scss" />

<style>
.donut-graph .graph .stat-middle-graph-value {
  position: absolute;
  width: calc(var(--graph-size) - 48px);
  height: calc(var(--graph-size) - 48px);
  line-height: calc(var(--graph-size) - 48px);
  text-align: center;
  border-radius: 50%;
  top: -6px;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  font-size: 12px;
}
</style>
